<div class="container-fluid col-md-10 content">
    <br>
    <div class=" static container-fluid mr-0 ml-0 pl-0">
        <img src="assets/svg/Page 3.svg" alt="">
    </div>
    <div class="container-fluid progress-heading row mt-3 mr-0 ml-0">
        <div class="col-md-3 pr-0 pl-0 ">
            <h6 class="text-center step pr-5">Step 1</h6>
            <h6 class="text-center info">General Information</h6>
        </div>
        <div class="col-md-3 pl-0 pr-0 ">
            <h6 class="text-center step pr-5">Step 2</h6>
            <h6 class="text-center info ">Capabilities</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step pr-3">Step 3</h6>
            <h6 class="text-center info ">Terms & Conditions</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step inactive">Step 4</h6>
            <h6 class="text-center info inactive">Completed</h6>
        </div>
    </div>
    <div class="primary-box">
        <h6 class="head">Terms and Conditions</h6>
        <div class="terms">
            <html>

            <head>
                <meta http-equiv=Content-Type content="text/html; charset=windows-1252">
                <meta name=Generator content="Microsoft Word 15 (filtered)">
                <style>
                    <!--
                    /* Font Definitions */
                    /* Style Definitions */
                    
                    p.MsoNormal,
                    li.MsoNormal,
                    div.MsoNormal {
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 8.0pt;
                        margin-left: 0cm;
                        line-height: 107%;
                        font-size: 11.0pt;
                        font-family: "Calibri", sans-serif;
                        color: black;
                    }
                    
                    p.MsoFooter,
                    li.MsoFooter,
                    div.MsoFooter {
                        mso-style-link: "Footer Char";
                        margin: 0cm;
                        font-size: 11.0pt;
                        font-family: "Calibri", sans-serif;
                        color: black;
                    }
                    
                    a:link,
                    span.MsoHyperlink {
                        color: #0563C1;
                        text-decoration: underline;
                    }
                    
                    p.MsoListParagraph,
                    li.MsoListParagraph,
                    div.MsoListParagraph {
                        mso-style-link: "List Paragraph Char";
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 9.0pt;
                        margin-left: 36.0pt;
                        text-align: justify;
                        font-size: 11.0pt;
                        font-family: "Arial", sans-serif;
                    }
                    
                    p.MsoListParagraphCxSpFirst,
                    li.MsoListParagraphCxSpFirst,
                    div.MsoListParagraphCxSpFirst {
                        mso-style-link: "List Paragraph Char";
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 0cm;
                        margin-left: 36.0pt;
                        text-align: justify;
                        font-size: 11.0pt;
                        font-family: "Arial", sans-serif;
                    }
                    
                    p.MsoListParagraphCxSpMiddle,
                    li.MsoListParagraphCxSpMiddle,
                    div.MsoListParagraphCxSpMiddle {
                        mso-style-link: "List Paragraph Char";
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 0cm;
                        margin-left: 36.0pt;
                        text-align: justify;
                        font-size: 11.0pt;
                        font-family: "Arial", sans-serif;
                    }
                    
                    p.MsoListParagraphCxSpLast,
                    li.MsoListParagraphCxSpLast,
                    div.MsoListParagraphCxSpLast {
                        mso-style-link: "List Paragraph Char";
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 9.0pt;
                        margin-left: 36.0pt;
                        text-align: justify;
                        font-size: 11.0pt;
                        font-family: "Arial", sans-serif;
                    }
                    
                    span.FooterChar {
                        mso-style-name: "Footer Char";
                        mso-style-link: Footer;
                        font-family: "Calibri", sans-serif;
                        color: black;
                    }
                    
                    p.Heading1b,
                    li.Heading1b,
                    div.Heading1b {
                        mso-style-name: "Heading 1b";
                        margin-top: 0cm;
                        margin-right: 0cm;
                        margin-bottom: 9.0pt;
                        margin-left: 0cm;
                        text-align: justify;
                        page-break-after: avoid;
                        border: none;
                        padding: 0cm;
                        font-size: 12.0pt;
                        font-family: "Arial \(W1\)";
                        font-weight: bold;
                    }
                    
                    span.ListParagraphChar {
                        mso-style-name: "List Paragraph Char";
                        mso-style-link: "List Paragraph";
                        font-family: "Arial", sans-serif;
                    }
                    
                    .MsoChpDefault {
                        font-size: 12.0pt;
                        font-family: "Calibri", sans-serif;
                    }
                    /* Page Definitions */
                    
                    @page WordSection1 {
                        size: 595.3pt 841.9pt;
                        margin: 72.0pt 72.0pt 72.0pt 72.0pt;
                    }
                    
                    div.WordSection1 {
                        page: WordSection1;
                    }
                    /* List Definitions */
                    
                    ol {
                        margin-bottom: 0cm;
                    }
                    
                    ul {
                        margin-bottom: 0cm;
                    }
                    
                    -->
                </style>

            </head>

            <body lang=EN-IN link="#0563C1" vlink="#954F72" style='word-wrap:break-word'>

                <div class=WordSection1>

                    <div style='border:none;border-top:solid windowtext 1.0pt;padding:7.0pt 0cm 0cm 0cm'>

                        <p class=Heading1b align=center style='text-align:center;page-break-after:auto;
                border:none;padding:0cm'><span lang=EN-AU style='font-family:"Times New Roman",serif'>Truventor
                Supplier Terms and Conditions</span></p>

                        <p class=Heading1b align=center style='text-align:center;page-break-after:auto;
                border:none;padding:0cm'><i><u><span lang=EN-AU style='font-family:"Times New Roman",serif;
                font-weight:normal'>Last Modified On : 16-07-2021</span></u></i></p>

                    </div>

                    <p class=Heading1b style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-indent:-35.45pt;border:none'><span lang=EN-AU style='font-family:"Arial",sans-serif;color:black'>1<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-size:11.0pt;font-family:"Times New Roman",serif'>Overview</span></p>

                    <p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>1.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Truventor
                AI and Robotics Pty Ltd ACN 622 249 969 (<b>we, us, our, TV</b>) operates an
                online intelligent cloud manufacturing platform with domain address </span><span lang=EN-AU><a target="_blank" href="https://www.truventor.com/"><span style='font-family:"Times New Roman",serif'>www.truventor.com</span></a>
                        </span><span lang=EN-AU style='font-family:"Times New Roman",serif'> and related
                applications (<b>Platform</b>) on which clients (<b>Clients</b>) can access a
                range of manufacturing services from us and our registered suppliers (<b>Supplier,
                you, your</b>). These terms and conditions (<b>Terms and Conditions</b>)
                constitute an agreement between us and you for the purpose of your use of the Platform
                and any services offered by the Platform from time to time. These are the Supplier
                terms and conditions and apply to Suppliers only. </span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>1.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If
                you are a Client, please access our Client Terms and Conditions at </span><span lang=EN-AU><a
               target="_blank" href="https://res.cloudinary.com/dzz4lppcu/image/upload/v1625556392/Client_Terms_and_Conditions.pdf"><span
                style='font-family:"Times New Roman",serif'>link.</span></a>
                        </span>
                    </p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>1.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                key features of our Platform include:</span></p>

                    <p class=MsoListParagraphCxSpMiddle><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:70.9pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Truventor
                Manufacture (<b>TV Manufacture</b>), an online manufacturing service through
                which Clients can:</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt;text-indent:-35.4pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(i)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Place
                manufacturing orders; </span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt;text-indent:-35.4pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(ii)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Upload
                3D models and designs relating to parts, assembly requirements, or products (<b>Designs</b>)
                for their manufacturing projects; </span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt;text-indent:-35.4pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(iii)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Have
                their Designs manufactured; and</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt;text-indent:-35.4pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(iv)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Through
                which you can receive and accept manufacturing orders from Clients.</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:106.3pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:70.9pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Truventor
                Manage (<b>TV Manage</b>), an online marketplace and software as a service through
                which Clients can access and manage a private network of their own independent Suppliers.
                </span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:70.9pt'><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:70.9pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Other
                Truventor services which may be available through the Platform.</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>(<b>Services</b>)</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:70.9pt'><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>1.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                reserve the right to update, modify, replace, limit, and expand the Platform
                and the Services. </span></p>

                    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
                margin-bottom:0cm;margin-left:35.45pt;text-indent:-35.45pt'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>1.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                should read these Terms and Conditions carefully prior to using the Platform. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm'><span lang=EN-AU style='font-family:
                "Times New Roman",serif'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Acceptance of Terms and Conditions</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>2.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>These Terms and Conditions record an agreement between you and us
                for the purpose of you browsing or using the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>2.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>By using the Platform you are accepting these Terms and Conditions
                and agree to be bound by them. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>2.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We reserve the right to make changes to these Terms and Conditions
                from time to time without notice. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Use</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>To use the Platform, you must register for an account in
                accordance with this clause. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>To register for an account, you must be a manufacturer or supplier
                that meets our standards and requirements to operate as a Truventor Supplier. </span></p>

                    <p class=MsoListParagraph><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>To register an account and / or place an order, you may be
                required to provide (among other things):</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Your name; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Details of your business, including:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;text-indent:-35.4pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(i)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Name;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;text-indent:-35.4pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(ii)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Address; and</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;text-indent:-35.4pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(iii)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any other required details.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Valid contact details including;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;text-indent:-35.4pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(i)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>An email address; and</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:106.3pt;text-align:justify;text-indent:-35.4pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(ii)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>A telephone number. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>A name and address for delivery purposes; and</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(e)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any other information required to complete the registration or
                ordering process,</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-left:35.45pt;text-align:justify'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>(<b>Supplier
                Data</b>). </span></p>

                    <p class=MsoNormal style='margin-left:35.45pt;text-align:justify'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>What
                constitutes Supplier Data may vary from time to time, noting that we may
                require additional information to that set out above. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Failure to supply correct Supplier Data may result in us being
                unable to provide the Services, and / or may limit your access to the Platform.
                </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We reserve the right to decline your registration request if you
                do not comply with our registration requirements as detailed in these Terms and
                Conditions and on the Platform. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree to permit us to use your Supplier Data for the purpose
                of providing the </span><span lang=EN-AU style='font-family:"Times New Roman",serif'>functionality
                of the Platform and any related purpose. You acknowledge that in order to do
                so, we may share the Supplier Data internally, and with other parties,
                including Clients, financiers, logistic partners and other stakeholders.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm'><span lang=EN-AU style='font-family:
                "Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree to use the Platforms for their intended purpose. You may
                not use the Platform for any illegal or unauthorised purpose, including the
                transmission of malware. You must not use the Platform to violate any laws,
                including but not limited to copyright laws. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.8<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must not use the Platform for any unconscionable behaviour or
                activity, including but not limited to:</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Engaging in abusive, derogatory, discriminatory, or vexatious
                behaviour;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Engaging in any activity that disrupts or corrupts the Platform or
                the networks that host the Platform; or</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Attempting to hack, reverse-engineer, disable, circumvent, or
                otherwise gain access to any security, database, or other secure aspect of the Platform.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.9<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                are res</span><span lang=EN-AU style='font-family:"Times New Roman",serif'>ponsible
                for maintaining the security of your login and account information (including
                the password). We are not liable for any loss or damage from your failure to
                comply with this security obligation.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.10<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                are responsible for all activities that occur on your account, and we will not
                be liable for any loss or damage from activities on your account. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.11<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>All<b>
                </b> Supplier Data will be stored and maintained by or on behalf of us in
                accordance with applicable laws.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.12<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                may from time to time email you regarding our Service or third party products
                or services that may be of interest to you. The emails may contain code that
                enables our database to track your usage of the emails, including whether the
                email was opened and / or what links (if any) were clicked. We may use this
                information to improve the functionality of the Platform and to improve the
                Service for you. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>3.13<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Our
                use of any information provided within the Supplier Data will be in accordance
                with our Privacy Policy available at </span><span lang=EN-AU><a target="_blank"
                href="https://res.cloudinary.com/dzz4lppcu/image/upload/v1625556392/Privacy_Policy.pdf"><span
                style='font-family:"Times New Roman",serif'>link.</span></a>
                        </span>
                    </p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><i><span lang=EN-AU style='font-family:"Times New Roman",serif'>TV
                Manufacture  Clauses </span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>4</span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'> to </span></i></b><b><i><span lang=EN-AU style='font-family:"Times New Roman",serif'>10</span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'> apply to your use of TV
                Manufacture</span></i></b></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref63417936"><b><span lang=EN-AU style='font-size:12.0pt;
                font-family:"Arial",sans-serif'>4<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Supplier
                Standards</span></b></a></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>4.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                require that our Suppliers and their manufacturing process meets relevant
                standards and regulations. We may require that you provide proof of compliance
                with such relevant standards and code. If we request proof of compliance of
                such standards and codes, you are required to provide proof within a reasonable
                time, and in any event not less than within 14 days of request. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>4.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If
                we learn, suspect, or have reason to suspect that you do not meet relevant
                standards and regulations, we may terminate or suspend your account until such
                time as we are satisfied that such standards have been met. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Receiving
                Orders</span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>
                </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>To
                place a manufacturing order (<b>Order</b>) on TV Manufacture to have a product
                (<b>Product</b>) manufactured, a Client will first upload a request for
                quotation consisting of a Design, raw material specification, and other details
                as required (<b>RFQ</b>).</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Once
                a RFQ is uploaded, subject to clause </span><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.6</span><span lang=EN-AU style='font-family:"Times New Roman",serif'>, the Platform will
                extract the data from the Design to calculate timelines and pricing of parts to
                complete the Order. The Design and other information contained in the Order
                will constitute the Clients Order specifications (<b>Specifications</b>). </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Once
                an order is accepted and paid for by a Client, we will submit the Order to our
                Suppliers to manufacture. You will then be invited to prepare a quote to
                complete the Order. The quote must include, at a minimum:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Your
                fee<b> </b>(<b>Fee</b>) to complete the Order, including a comprehensive
                breakdown of all charges included in your Fee; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                estimated timeline to complete and deliver the Order including shipping and
                delivery; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Payment
                details for receipt of payment; and</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any
                other information that may be required from us when we submit the Order and/or
                RFQ. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(<b>Quote</b>)</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We retain
                full discretion as to which Supplier we engage to manufacture an Order. In
                determining a Supplier to fulfil an Order, we may consider, among other things,
                the quote provided by the Supplier to fill the Order, the timelines provided by
                the Supplier, the Suppliers location, and the suitability of the Supplier for
                the specific Order. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                may refuse an Order that has been referred to you, or elect not to provide a Quote
                for an Order. Where you provide a Quote and that Quote is accepted by us, you
                are required to complete the Order in accordance with the Details of Quote. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref71877225"><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Particularly
                large Orders or Orders with specific manufacturing requirements, may require us
                to submit the RFQ to our Suppliers to review and provide a Quote. If we refer
                a RFQ to you for this purpose, we require that you answer the quote within a 48
                hours period, subject to weekends and public holidays. RFQs may be referred to
                you only, or to a number of Suppliers. Once the RFQ is answered, we will pass
                the quoted cost and delivery timelines on to the Client.</span></a><span lang=EN-AU style='font-family:"Times New Roman",serif'> </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>5.7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Upon
                a Quote being accepted by us, you will manufacture or have manufactured the Order
                in accordance with the Specifications and the Quote. You are solely responsible
                for ensuring that the Product manufactured is functional, complete, and in
                accordance with the Quote and Specifications. You indemnify us fully against
                any claims brought against us by a Client, whether for damages or any other
                remedy, due to a fault, error, or defect caused to the Product by you. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Pricing
                and Payment </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>6.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>When
                you provide a Quote to complete an Order, the Fee contained in the Quote will
                be inclusive of all costs and charges associated with your fulfillment of the
                Order, including any applicable tax. For the avoidance of doubt, we will be
                under no obligation to pay you any amount in excess of the Fee unless otherwise
                agreed in writing. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>6.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Once
                an Order is completed and the Product is delivered to the Client, the Client
                will have the opportunity to conduct an inspection of the Product and accept
                the Product. Payment of the Fee will not be remitted to you until such time as
                the Client confirms its acceptance of the Product. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>6.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Once
                the Product is accepted by the Client, we will pay you in accordance with the
                Quote to your elected bank account. You are fully responsible for ensuring that
                you have provided us with complete and accurate payment details. We accept no
                liability for any loss or damage caused by you providing incorrect or
                incomplete payment details. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>6.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If a
                Product is not accepted by a Client due to a fault or defect caused by you, we
                reserve the right to withhold payment. If, upon our inspection, we confirm that
                the fault or defect was caused by you, you will have the right to repair the fault
                or defect at your own cost. We reserve the right to apply and deduct any
                damages caused by any defect or fault caused by you against the Fee.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>6.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                use a third-party service provider for provision of the payment service and we
                are not liable for any issues, including charges from your financial institution,
                which may arise as a result of this service.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Manufacturing
                an Order</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>7.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If
                any alteration, modification, or change to the Specifications of any Order is
                required to complete the Order, you must notify us of this requirement as soon
                as is reasonably practical after becoming aware. You must not depart from the
                Specifications without our prior approval. You indemnify us fully against any
                claim brought against us by a Client due a departure by you from the
                Specifications without our approval. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>7.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                do not allow the manufacture of any Order that is illegal or designed to cause
                harm or injury to any human, or which is designed with the intention of
                facilitating any illegal activity such as but not limited to the product of
                illicit drugs, the unlawful destruction of property, or any other criminal
                activity. If you become aware or reasonably suspect that an Order that you are
                manufacturing is being manufactured for any illegal or unethical purpose, you
                must cease manufacturing the Order immediately and raise your concerns with us.
                We will then conduct our own investigation and advise accordingly. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>7.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Orders
                must be manufactured in accordance with relevant standards and regulations. All
                our Suppliers are required to be compliant with relevant standards and
                regulations, which we may inform you of from time to time. You must not depart
                from these standards and regulations. You fully indemnify us against any claim
                bought against us by any party, including of a government, pseudo-government,
                or regulatory body as a result of you departing from applicable manufacturing
                standards and regulations. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>7.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>All
                Orders must be manufactured with care, expertise, and professionalism. As a
                Truventor Supplier, you are expected to meet certain standards of quality and
                expertise. If we determine that you are incapable of or for whatever reason
                failing to meet our standards of quality and expertise, we may cancel your
                account. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>8<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Shipping</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>8.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You must
                provide an estimated shipping date at the time you submit a Quote. You must
                make all reasonable endeavours to meet the shipping date provided. You must let
                us know immediately if you will be unable to meet the shipping date provided so
                that we may manage the Clients expectations. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>8.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                must ensure that the completed Product is shipped according to our
                instructions. All Products shipped must be shipped in a way that is safe and
                secure, and does not jeapordize the integrity of the completed Product. You
                must make reasonable endeavours to ensure that Products are protected from physical
                harm or damage during the shipping process. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>8.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                will provide you the delivery address for the completed Product to be shipped
                too. It is your responsibility to ensure that the Product is shipped to the
                correct address, and you fully indemnify us against any claims for damages
                brought against us by a Client due to you shipping a Product to an incorrect
                address. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>9<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Product</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>9.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Upon
                delivery of a Product, the Client will have the opportunity to inspect the
                Product. If the Client identifies that there is a fault or defect contained in
                the Product, we will conduct an internal investigation to confirm whether this
                is the case. If we determine that there is a fault or defect in the Product,
                and we determine that the fault or defect was caused by you, you agree that you
                will take any steps reasonably required by us to remedy the fault or defect.
                This may include but is not limited to:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Repairing
                the fault or defect; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Replacing
                the product; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If
                the fault or defect relates only to a part or component of the Product,
                replacing or repairing the part or component; or </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any
                other steps reasonably required by us. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref63417990"><b><span lang=EN-AU style='font-size:12.0pt;
                font-family:"Arial",sans-serif'>10<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Intellectual
                Property in the Design and Product</span></b></a><b><span lang=EN-AU
                style='font-family:"Times New Roman",serif'> </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>10.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                Client will upload Specifications, Designs, and other content or data on to the
                Platform (<b>Client IP</b>). We claim no ownership over the Client IP, and all
                intellectual property and other proprietary rights in the Client IP remains the
                sole and exclusive property of the Client. Where the Client IP is shared with
                you, you agree to only use the Client IP for the purposes of providing a Quote
                and, if applicable, fulfilling the Order. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>10.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                shall treat all Client IP with the utmost confidentiality. If you are required
                to share the Client IP with any party, including your employees, partners,
                contractors, suppliers, stakeholders, and affiliates, you must take reasonable
                steps to ensure that they comply with the requirements of this clause. You must
                take reasonable steps to ensure the security of any Client IP accessed or held
                by you, and ensure that the Client IP is protected from theft, hacking, or
                leaking. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>10.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                fully indemnify and hold harmless us against any claims for damages or any
                other remedy made against us by a Client or any other party due to a breach of
                the proprietary rights of a Client in the Client IP. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>10.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>If
                we become aware, suspect, or have reason to suspect that you are in breach of
                your confidentiality requirements with respect to any Client IP, your account
                may be terminated or suspended, and we may take any legal action against you
                that we see fit to remedy such breach including but not limited to damages,
                injunctions, or any other remedy available to us at law. </span></p>

                    <p class=MsoNormal style='margin-bottom:9.0pt;text-align:justify;line-height:
                normal;border:none'><b><i><span lang=EN-AU style='font-family:"Times New Roman",serif'>TV
                Manage  Clauses </span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>11</span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'> to </span></i></b><b><i><span lang=EN-AU style='font-family:"Times New Roman",serif'>15</span></i></b><b><i><span
                lang=EN-AU style='font-family:"Times New Roman",serif'> apply to your use of TV
                Manage</span></i></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref63419991"><b><span lang=EN-AU style='font-size:12.0pt;
                font-family:"Arial",sans-serif'>11<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Marketplace
                Only</span></b></a></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>TV Manage provides a marketplace and software as a service through
                which Clients can engage with and manage their network of Suppliers, which
                includes access to our network of Suppliers, and buy products or services from Suppliers
                (<b>Transaction</b>). Our involvement in the Transaction is limited to that of
                a facilitator to the Transaction. We are not and do not purport to be a Supplier,
                manufacturer, guarantor, or otherwise a contractual party to the Transaction. We
                are in no way responsible for completion of you or the Clients obligations and
                by transacting with the Client you assume all legal and transaction risk in
                dealing with the Client. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Our involvement in the Transaction is limited to the following
                capacity:</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Connecting you with Clients via TV Manage;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Facilitating the Transaction by allowing the Client and you to
                engage through TV Manage and facilitate all steps of the Transaction; and </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Collecting payment from the Client and remitting it to you. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>When you engage with a Client through TV Manage, you are entering
                a legally binding contract with the Client. We are not a party to this contract
                and are not responsible for the performance of your or the Clients obligations
                under the contract. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You may have your own terms and conditions, standard form
                contracts, or other agreements that Clients may be required to adhere to in
                engaging you (<b>Supplier Terms</b>). When this is the case, the Transaction is
                subject to the Supplier Terms.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Where you do not have any Supplier Terms, the Transaction will be
                subject to terms and conditions implied at law, and implied by your conduct and
                exchanges with the Client. Please make yourself aware of such implied
                conditions before entering the Transaction. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>11.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>By using TV Manage, you fully release and discharge us from any
                claims, actions, demands or proceedings which may arise from a Transaction. You
                agree that we are in no way liable for any obligation arising from a
                Transaction, including but not limited to:</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Delivery or performance of a product or service; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>The quality or standard of a product or service; </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Reimbursement, compensation, or damages arising from a product or
                service;</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Product or service warranties that you may provide; or</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'></span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(e)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Product or service warranties and obligations placed on you in
                relation to a product or service under a relevant law. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>12<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Pricing and Payment </span></b></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Product prices and delivery charges must include taxes including
                GST and other taxes where applicable.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Purchases are placed and paid for through the payment processing
                facility contained on the Platform, using the payment methods designated by the
                Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>When a Client initiates a Transaction on the Platform, payment for
                the Transaction will be accepted and processed by us or our nominated
                third-party payment processor, and the Order will be sent to you. You must
                accept the Order if you have the capacity to provide the relevant service. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must reject the Order if you are unable to fulfil the order. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must provide confirmation that you have accepted or rejected
                the Order within 1 business day of the Order being placed. Failure to do so may
                result in the Transaction being cancelled and the payment being refunded to the
                Client. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>If you cancel an order that has already been processed, or
                otherwise fail to deliver to the Client the Clients order whether in full or
                in part, you agree that any complaint, demand for refund or remedy, legal
                action, or action otherwise is to be taken against you directly and you fully indemnify
                us against any such action. To the maximum extent permitted by law, we will not
                be liable to you for any loss, whether liquidated or otherwise, associated with
                you entering into a Transaction with a Client. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>It is your responsibility to ensure your payment details are valid
                and up to date. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref48221602"><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.8<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Subject to this clause, upon completion of a Transaction, you are
                entitled to receive payment for the Order completed (<b>Supplier Fee</b>). The Supplier
                Fee will be the amount paid by the Client in a Transaction, less:</span></a></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any applicable transaction fee as notified to you from time to
                time; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any applicable third-party fees as notified to you from time to
                time; and</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any other amount which you owe to us. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.9<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>The Supplier Fee will be remitted to you upon completion of the
                Transaction.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.10<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>Details of
                the amount, if any, deducted from the Supplier Fee will be provided at the time
                you are remitted the Supplier Fee.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.11<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>In the event
                that we suspect the existence of a fraudulent or fake account:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:25.2pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We reserve the right to investigate all accounts where we suspect such
                activity.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:25.2pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We reserve the right to terminate your order following the
                investigation.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>12.12<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>We are in no
                way liable for payment failure or other transactional risks even in circumstances
                where you may have already despatched products or provided services. You hold us
                entirely harmless in relation to any and all obligations in this regard. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>13<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Your Obligations </span></b></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree that you will interact with Clients with
                professionalism, respect and decency. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree that you all products or services listed on the
                Platforms and your accompanying terms of sale will be compliant with all
                relevant standards, laws and applicable regulations and codes. You agree that
                all manufacturing services you supply over the Platform are provided to Clients
                with acceptable care and skill and all applicable standards and obligations
                under law. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Respond to Clients within 1 business day of receiving a
                communication from a Client; </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Ship products within the estimated delivery time provided to a Client
                in a Transaction; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Respond to and resolve customer complaints without unnecessary
                delay; and</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Fairly and lawfully comply with your returns policies and
                procedures set out in your Suppler Terms and comply with these Terms and
                Conditions in responding to and handling Client complaints.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You bear sole responsibility for maintaining your listings and
                associated information in accordance with our guidelines which are accessible
                via the Platforms and may be updated from time to time. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Your profile must be accurate and a true depiction of the products
                or services offered by you. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You warrant and guarantee that you have full authority, title, and
                legal right and capacity to offer your manufacturing services. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree that will not provide false or misleading information to
                us or to a Client.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.8<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You will provide Clients with proof of transaction for all orders.</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.9<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You agree that you will not use the Platforms as a means of lead
                generation. You agree that you will not contact Clients by reaching out to them
                outside of the context of the Platforms. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>13.10<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>You agree
                that you will not accept any payment for a product or service from a Client
                directly, and that all payments must be processed by us or our nominated third
                party payment processor, and that all Transactions with Clients must take place
                through the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>14<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Delivery and Performance</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                are responsible for the delivery of a product or performance of a service the
                subject of a Transaction. We are not responsible and accept no responsibility
                for the delivery of a product or performance of a service listed on the </span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>Platforms</span><span lang=EN-AU style='font-family:"Times New Roman",serif'>. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><b><span lang=EN-AU
                style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Failure
                to deliver a product or perform a service listed on the </span><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>Platforms</span><span lang=EN-AU style='font-family:"Times New Roman",serif'> to a Client may result
                in your account being terminated or suspended. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must provide timeframes to the Client setting out the expected
                time for delivery of a product or performance of a service where possible.
                Where timeframes are provided, you must endeavour to take required steps to
                meet the timeframe provided. You agree and acknowledge that a Client may
                contact you directly to ascertain an estimated timeframe. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
                normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You are responsible for delivery to the Client. We are not
                responsible and accept no liability for delivery or performance of a service
                you have listed on the Platforms. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You may only execute partial delivery of an order to a Client with
                the express prior permission of the Client, which must be attained by
                contacting the Client through the Platform. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>14.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Where you have had a dealing with a Client in which the Client has
                breached these Terms and Conditions or the Suppler Terms you may report this
                breach to us to investigate. We may at our own discretion suspend the Client
                from the Platforms, or take other such remedial action as we deem appropriate. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><a name="_Ref70427941"><b><span lang=EN-AU style='font-size:12.0pt;
                font-family:"Arial",sans-serif'>15<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Refunds and returns</span></b></a></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Notwithstanding any other provision of these Terms and Conditions,
                we are in no way required to refund any money spent on a Transaction. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Where a refund is required or requested by a Client, you agree
                that the Client can contact you directly to arrange or request such a refund. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black;background:
                yellow'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Clients may also request refunds through our team. In such
                circumstances, we will review the refund request and forward it to you with any
                of our own comments. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>You must execute refunds promptly and in any case within 2
                business days of the request for a refund. If you fail to execute a refund
                within 2 business days, we may exercise our authority to execute the refund on
                your behalf, in which event the amount refunded will be a debt payable by you
                to us upon demand. We may elect to deduct the refund from the Supplier Fee. </span></p>

                    <p class=MsoListParagraph style='margin-bottom:0cm'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any claims under any consumer law with respect to a product or
                service are against you only and you agree and fully release, discharge and
                indemnify us from and against any liability, claim, or action against the
                supply or delivery of a service or product under any consumer law. </span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>15.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We may require that you refund the full or partial amount paid by
                a Client in a Transaction to a Client where:</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>We consider that the Client is entitled to a refund under law;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Where a Client is entitled to a refund because you have breached
                these Terms and Conditions; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Where you have delivered faulty goods or an inadequate service; or</span></p>

                    <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif;
                color:black'>Any other valid reason.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>&nbsp;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal'><span lang=EN-AU style='font-family:"Times New Roman",serif;color:black'>Where we require you to
                refund an amount to a Client, you must do so within 2 business days of being
                notified of this requirement. Failure to comply with this requirement may
                result in your account being cancelled, terminated, or suspended. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>16<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Intellectual
                Property in the Platform </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>16.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Nothing
                in these Terms and Conditions or otherwise creates an assignment of any rights
                in the Platform beyond the ability to use it for its intended use. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
                margin-left:35.45pt;text-align:justify;line-height:normal;border:none'><b><span
                lang=EN-AU style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>16.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Nothing
                in these Terms and Conditions or otherwise creates the right for you to
                sublicense the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>16.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>By
                accepting these Terms and Conditions you undertake not to reverse engineer,
                replicate, or otherwise copy the Platform. We reserve all our rights to seek
                compensation, damages, injunctions, or any other remedy available to us at law
                if any attempt to do so, whether successful or unsuccessful, is made by you,
                your business or its members, employees, officers, affiliates, customers, or
                anyone else. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>16.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>All
                intellectual property and ownership rights subsisting in the Platform
                (including the user interface and the software comprising the Platform), the
                data derived from use of the Platform, and any other documentation, information
                or materials that are supplied by the Platform to you, remain our or our third party
                licensors exclusive property. For the avoidance of doubt, nothing in these
                Terms and Conditions assigns any ownership rights to you.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>17<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Operation
                of the Platform</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>17.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>As a
                user of the Platform you warrant that you will comply fully with all of our
                operating instructions. Any failure to comply fully with operating instructions
                may result in the sub-par or faulty performance of the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>17.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                accept no liability, and you release us from any such liability, associated
                with faults or errors caused by your non-compliance with all operating
                instructions. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>18<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Modifications
                to the Platform </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>18.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                reserve the right to modify or discontinue, temporarily or permanently the
                Platform and its products and services with or without notice.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>18.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                accept no liability if any such modification or discontinuance causes any loss
                or damage to you or causes any disruptions to your use of the Platform.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>19<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Advertising</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>19.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We may
                display advertisements by third party sponsors on the Platform (<b>Ads</b>). In
                doing so, we do not warrant the functionality of the business, product, or
                service being advertised in the Ad. We do not hold ourselves out as partners,
                affiliates, guarantors, or has having any other type of legal or professional
                relationship with the third party sponsors. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>19.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Where
                Ads link to third party websites, we do not warrant the safety, functionality,
                or suitability of these websites. We are in no way liable for any loss, damage,
                risk or liability incurred from you visiting any third party websites
                accessible through Ads. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>19.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Advertised
                third party websites may be subject to their own terms and conditions. We do
                not warrant the validity or suitability of these third party terms and
                conditions. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>20<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Warranties</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>20.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>By
                using the Platform, you represent and warrant to use that we will not be liable
                for any direct or indirect expense, damage or injury (including indirect loss
                of revenue, profits, goodwill or business opportunity) howsoever caused,
                including arising directly or indirectly from or in connection with your use of
                the Platform.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>20.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Subject
                to any of the rights you may have under consumer protection laws, we exclude to
                the fullest extent possible all implied terms and warranties, whether statutory
                or otherwise, relating to the Platform or any other matter under these Terms
                and Conditions.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>21<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Limitation
                of liability </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>21.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                Platform is made available to you on an as is basis. We make no warranties,
                representations or conditions of any kind, express, statutory or implied as to:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                operation and functionality of the Platform;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>the
                accuracy, integrity, completeness, quality, legality, usefulness, safety and IP
                rights of any of the Platform content; and/or</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>the
                products and services associated with the Platform or its content. We further
                disclaim all warranties, express, statutory or implied, including, but not
                limited to, implied warranties of merchantability, merchantable quality,
                durability, fitness for a particular purpose and/or non-infringement. No advice
                or information, whether oral or written, that you obtain from us shall create
                any warranty, representation or condition not expressly stated herein.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>21.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We
                disclaim all liability for any:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>indirect,
                special, incidental, punitive, exemplary, reliance or consequential damages;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>loss
                of profits;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>business
                interruption;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>network
                interruptions; </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(e)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>loss
                or damage to reputation of us or any third party; or</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(f)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>loss
                of information or data. We further disclaim all liability for any loss or
                damage arising out of your use of the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>21.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Your
                use of the Platform is at your own discretion and risk, and you will be solely
                responsible for any resulting loss or damage, including but not limited to, any
                loss of data or damage to your computer(s) or networks from viruses that may be
                downloaded to your computer in the course of using the Platform. Some
                jurisdictions do not allow the exclusion of certain warranties, the limitation
                or exclusion of implied warranties, or limitations on how long an implied
                warranty may last, so the above limitations may not apply to you. If you reside
                in such a jurisdiction, the above limitations shall apply to you to the fullest
                extent permitted under applicable law.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>22<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>Indemnity</span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>22.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                agree to defend, indemnify and hold harmless us, our members, managers,
                subsidiaries, affiliates, any related companies, suppliers, licensors and
                partners, and the officers, directors, employees, agents and representatives of
                each of them, including costs, liabilities and legal fees, from any claim or
                demand made by any third party due to or arising out of:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Your
                access to or use of the Platform;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Your
                violation of these Terms and Conditions;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any
                infringement by you of any intellectual property or other right of any person
                or entity. We reserve the right, at your expense, to assume the exclusive
                defence and control of any matter for which you are required to indemnify us
                and you agree to cooperate with our defence of these claims. You agree not to
                settle any matter without our prior written consent. We will use reasonable
                efforts to notify you of any such claim, action or proceeding upon becoming
                aware of it.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><b><span lang=EN-AU style='font-size:12.0pt;font-family:"Arial",sans-serif'>23<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span></b><b><span lang=EN-AU style='font-family:"Times New Roman",serif'>General
                </span></b></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.1<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>To
                the extent permitted by law, we reserve the right to create, collect and / or
                store any metadata resulting from your use of the Platform. To the extent
                permitted by law, we may use metadata for a variety of functions including (but
                not limited to) conducting investigations, helping us manage and administer the
                Platform, for purposes of search engine optimisation and to drive traffic to the
                Platform. To the extent permitted by law, we reserve the right to share your
                information (including metadata) with government agencies and authorities to
                the extent this is required or requested of us.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.2<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                understand that we use third party vendors and hosting partners to provide the
                necessary hardware, software, networking, storage, and related technology
                required to run the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.3<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                must not modify, adapt or hack the Platform or modify another website or
                software so as to falsely imply that it is associated with the Platform or us. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.4<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of
                the Platform, use of the Platform, or access to the Platform without our prior
                written express permission. We claim copyright and all other intellectual
                property rights over the Platform and its other products and services and
                reserves all of our rights.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.5<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Verbal,
                physical, written or other abuse (including threats of abuse or retribution) of
                any of our employees, members, representatives, or officers may result in you
                being banned from the Platform. </span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.6<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We do
                not warrant that:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                Platform will meet your specific requirements;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The
                Platform will be uninterrupted, timely, secure, or error-free;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>The content
                that may be obtained from the use of the Platform will be accurate or reliable;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(d)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any
                errors in the Platform will be corrected.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.7<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>You
                expressly understand, agree and warrant that we shall not be liable for any
                direct, indirect, incidental, special, consequential or exemplary damages,
                including but not limited to, damages for loss of profits, goodwill, use, data
                or other intangible losses (even if we have been advised of the possibility of
                such damages), resulting from:</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(a)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>the
                use or the inability to use the Platform;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(b)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>unauthorised
                access to or alteration of your transmissions or data;</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:70.9pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>(c)<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>or
                any other matter relating to the Platform.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.8<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Our
                failure to exercise or enforce any right or provision of these Terms and
                Conditions shall not constitute a waiver of such right or provision. The Terms
                and Conditions constitutes the entire agreement between you and us and governs
                your use of the Platform, superseding any prior agreements between you and us.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.9<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any
                part of these Terms and Conditions that is invalid, prohibited or not
                enforceable will not void the balance of the Terms and Conditions. All other
                parts will be enforced without regard to the invalid provision and continue to
                be valid in accordance with their terms.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.10<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>We make no
                representations or warranties that the content of the Platform complies with
                the laws (including intellectual property laws) of your jurisdiction.</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.11<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>Any queries about the
                Terms and Conditions should be send to us by email at [</span><u><span
                lang=EN-AU style='font-family:"Times New Roman",serif;color:#2F5496'>care@truventor.com</span></u><span lang=EN-AU style='font-family:"Times New Roman",serif'>].</span></p>

                    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:9.0pt;
                margin-left:35.45pt;text-align:justify;text-indent:-35.45pt;line-height:normal;
                border:none'><span lang=EN-AU style='font-family:"Times New Roman",serif'>23.12<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang=EN-AU style='font-family:"Times New Roman",serif'>These Terms and
                Conditions are governed by the laws of the State of Victoria, Australia and you
                agree to be bound by the exclusive jurisdiction of the courts of Victoria. </span></p>

                    <p class=MsoNormal><span lang=EN-AU>&nbsp;</span></p>

                </div>

            </body>

            </html>

        </div>
    </div>
    <div class="container-fluid row mr-0 ml-0 mt-5 ">
        <mat-checkbox color="warn" (change)="acceptTerms($event.checked)" class="mt-1"></mat-checkbox> &nbsp;
        <p class="ml-2 check">I have read and accept all Terms And Conditions mentioned above.</p>
    </div>
    <div class="button row mt-5">
        <p class="col-md-9 pointer" (click)="back()">
            < Back</p>
                <button class="orange" [disabled]="is_accepted" (click)=" completeOnboarding()">Continue</button>
    </div>
</div>